import React from 'react';
import 'styles';
const YAxisComponent = () => {
  return (
    <div className="y-axis-wrapper">
      <svg width="30" height="400" viewBox="1 0 30 400">
        <g className="recharts-layer recharts-cartesian-axis recharts-yAxis yAxis">
          <line
            className="recharts-cartesian-axis-line"
            width="60"
            height="400"
            x="0"
            y="0"
            stroke="#666"
            fill="none"
            x1="30"
            y1="8"
            x2="30"
            y2="372"
          />
          <g className="recharts-cartesian-axis-ticks">
            <g className="rechaårts-layer recharts-cartesian-axis-tick">
              <line
                className="recharts-cartesian-axis-tick-line"
                width="60"
                height="350"
                x="0"
                y="20"
                stroke="#666"
                fill="none"
                x1="24"
                y1="360"
                x2="30"
                y2="360"
              />
              <text
                width="60"
                height="350"
                x="22"
                y="360"
                stroke="none"
                fill="#666"
                className="recharts-text recharts-cartesian-axis-tick-value"
                textAnchor="end">
                <tspan x="22" dy="0.355em">
                  0
                </tspan>
              </text>
            </g>
            <g className="recharts-layer recharts-cartesian-axis-tick">
              <line
                className="recharts-cartesian-axis-tick-line"
                width="60"
                height="350"
                x="0"
                y="20"
                stroke="#666"
                fill="none"
                x1="24"
                y1="290"
                x2="30"
                y2="290"
              />
              <text
                width="60"
                height="350"
                x="22"
                y="290"
                stroke="none"
                fill="#666"
                className="recharts-text recharts-cartesian-axis-tick-value"
                textAnchor="end">
                <tspan x="22" dy="0.355em">
                  20
                </tspan>
              </text>
            </g>
            <g className="recharts-layer recharts-cartesian-axis-tick">
              <line
                className="recharts-cartesian-axis-tick-line"
                width="60"
                height="350"
                x="0"
                y="20"
                stroke="#666"
                fill="none"
                x1="24"
                y1="220"
                x2="30"
                y2="220"
              />
              <text
                width="60"
                height="350"
                x="22"
                y="220"
                stroke="none"
                fill="#666"
                className="recharts-text recharts-cartesian-axis-tick-value"
                textAnchor="end">
                <tspan x="22" dy="0.355em">
                  40
                </tspan>
              </text>
            </g>
            <g className="recharts-layer recharts-cartesian-axis-tick">
              <line
                className="recharts-cartesian-axis-tick-line"
                width="60"
                height="350"
                x="0"
                y="20"
                stroke="#666"
                fill="none"
                x1="24"
                y1="150"
                x2="30"
                y2="150"
              />
              <text
                width="60"
                height="350"
                x="52"
                y="150"
                stroke="none"
                fill="#666"
                className="recharts-text recharts-cartesian-axis-tick-value"
                textAnchor="end">
                <tspan x="22" dy="0.355em">
                  60
                </tspan>
              </text>
            </g>
            <g className="recharts-layer recharts-cartesian-axis-tick">
              <line
                className="recharts-cartesian-axis-tick-line"
                width="60"
                height="350"
                x="0"
                y="20"
                stroke="#666"
                fill="none"
                x1="24"
                y1="80"
                x2="30"
                y2="80"
              />
              <text
                width="60"
                height="350"
                x="22"
                y="80"
                stroke="none"
                fill="#666"
                className="recharts-text recharts-cartesian-axis-tick-value"
                textAnchor="end">
                <tspan x="22" dy="0.355em">
                  80
                </tspan>
              </text>
            </g>
            <g className="recharts-layer recharts-cartesian-axis-tick">
              <line
                className="recharts-cartesian-axis-tick-line"
                width="60"
                height="350"
                x="0"
                y="20"
                stroke="#666"
                fill="none"
                x1="24"
                y1="10"
                x2="30"
                y2="10"
              />
              <text
                width="60"
                height="350"
                x="22"
                y="10"
                stroke="none"
                fill="#666"
                className="recharts-text recharts-cartesian-axis-tick-value"
                textAnchor="end">
                <tspan x="22" dy="0.355em">
                  100
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default YAxisComponent;
